/**
 * Useful for places where typescript wants you to have something but it also knows that nothing can be there,
 * like the default case of an exhaustive switch statement.
 */
export function assertUnreachable(): never {
  throw new Error("Unreachable code has been reached");
}

/**
 * Useful for places where typescript wants you to have something but it also knows that nothing can be there,
 * like the default case of an exhaustive switch statement.
 */
export function assertNever(value: never): never {
  throw new Error(`Unreachable code has been reached via value ${value}`);
}

export function assertNotNullish<T>(value: T | null | undefined): asserts value is T {
  if (value == null) {
    throw new Error("expected non-null");
  }
}

/**
 * Doesn't do anything, but if you call it in the "default" branch of a switch statement,
 * it will tell you if you forgot to include a member of the switch type
 */
export function compileOnlyAssertNever(value: never): void {}

/**
 * Helpful function if you want to log for local test purposes but don't want the log to go to production
 */
export function testLog(value: never): void {
  console.log(value);
}
